import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import Navbar from "../Navbar";
import Footer from "../Footer";
import ContactModal from "../ContactModal";
import "./index.css";

const Contact = () => {
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    // Replace these with your EmailJS credentials
    const SERVICE_ID = "service_jd326h7";
    const TEMPLATE_ID = "template_yihpcw7";
    const PUBLIC_KEY = "s2UJNEFO-RzRWsrii";

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, PUBLIC_KEY).then(
      (result) => {
        console.log("Email sent successfully:", result.text);
        setSubmitStatus("success");
        setIsSubmitting(false);
        formRef.current.reset();
      },
      (error) => {
        console.error("Email sending failed:", error.text);
        setSubmitStatus("error");
        setIsSubmitting(false);
      }
    );
  };

  return (
    <>
      <ContactModal />
      <Navbar />
      <div className="contact-page">
        <div className="contact-header">
          <h1>Contact Us</h1>
          <p>Get in touch with us for any inquiries about our properties</p>
        </div>
        <div className="contact-container">
          <div className="contact-content">
            <div className="info-item">
              <h3>📍 Address</h3>
              <p>Maduravoyal , MGR University Opposite,</p>
              <p>Chennai-600018, Tamil Nadu.</p>
            </div>

            <div className="info-item">
              <h3>📞 Phone</h3>
              <p>+(91) 9999999999 </p>
              <p>+(91) 9999999999 </p>
            </div>

            <div className="info-item">
              <h3>✉️ Email</h3>
              <p>Rkhousing77@gmail.com</p>
              <p>sales@rkhousing.com</p>
            </div>

            <div className="info-item">
              <h3>🕒 Working Hours</h3>
              <p>Monday - Saturday: 9:00 AM - 6:00 PM</p>
              <p>Sunday: Closed</p>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit} ref={formRef}>
            <h2>Send us a Message</h2>

            {submitStatus === "success" && (
              <div className="alert alert-success">
                ✓ Message sent successfully! We'll get back to you soon.
              </div>
            )}

            {submitStatus === "error" && (
              <div className="alert alert-error">
                ✗ Failed to send message. Please try again or contact us
                directly.
              </div>
            )}

            <div className="form-group">
              <input
                type="text"
                name="from_name"
                placeholder="Your Name"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="from_email"
                placeholder="Your Email"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="tel"
                name="phone"
                placeholder="Your Phone"
                required
              />
            </div>
            <div className="form-group">
              <select name="inquiry_type" required>
                <option value="">Select Inquiry Type</option>
                <option value="property">Property Inquiry</option>
                <option value="pricing">Pricing</option>
                <option value="visit">Schedule Visit</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div className="form-group">
              <textarea
                name="message"
                placeholder="Your Message"
                rows="5"
                required
              ></textarea>
            </div>
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>

        <div className="map-container">
          <iframe
            title="RK Housing Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d497511.11463437837!2d79.92880733435084!3d13.048043801320511!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265ea4f7d3361%3A0x6e61a70b6863d433!2sChennai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1642432085545!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
